// Lightbox state — ports lightbox.js (fullscreen image viewer). Any message
// image opens it; <Lightbox/> at the app root renders the overlay.
import { create } from 'zustand'

interface LightboxState {
  src: string | null
  open: (src: string) => void
  close: () => void
}

export const useLightboxStore = create<LightboxState>()((set) => ({
  src: null,
  open: (src) => set({ src }),
  close: () => set({ src: null }),
}))
